<div class="business-representative-form">
  <app-paragraph *ngIf="!hideInform && !migrating">{{ businessRepresentative.labels.inform }} 
    <strong>{{businessRepresentative.labels.emailInform}} </strong>
    {{businessRepresentative.labels.and}} 
    <strong>{{businessRepresentative.labels.passwordInform}} </strong>
    {{businessRepresentative.labels.inform2}}
    <ul>
      <li>{{businessRepresentative.labels.inform3}}</li>
    </ul>
  </app-paragraph>
  <app-image-upload icon="person"
                    id="representative-image-upload"
                    [animateImage]="animateImage"
                    [fileUploadLabel]="businessRepresentative.labels.fileUpload"
                    [fileUploadAlt]="businessRepresentative.labels.fileUploadAlt"
                    [abstractControl]="businessRepresentative.formGroup.get('picture')">
  </app-image-upload>
  <form [formGroup]="businessRepresentative.formGroup">
    <app-input id="representative-name-input"
               [control]="getControl('name')"
               [label]="businessRepresentative.labels.name"
               required>
    </app-input>
    <app-input id="representative-last-name-input"
               [control]="getControl('lastName')"
               [label]="businessRepresentative.labels.lastName"
               required>
    </app-input>
    <app-input id="representative-email-input"
               [control]="getControl('email')"
               [label]="businessRepresentative.labels.email"
               required>
    </app-input>
        <app-input id="representative-confirmEmail-input"
        [avoidPasting]="true"
        [control]="getControl('confirmEmail')"
        [label]="businessRepresentative.labels.confirmEmail"
        required
        *ngIf="!migrating">
    </app-input>
    <ng-container *ngIf="!migrating">
      <app-header class="middle-header">{{ businessRepresentative.labels.middleHeader }}</app-header>
      <app-input id="representative-password-input"
                 [control]="getControl('password')"
                 type="password"
                 [label]="businessRepresentative.labels.password"
                 required>
      </app-input>
      <app-input id="representative-confirm-password-input"
                 [control]="getControl('confirmPassword')"
                 type="password"
                 [label]="businessRepresentative.labels.confirmPassword"
                 required>
      </app-input>
      <app-form-feedback-list [abstractControl]="businessRepresentative.formGroup.get('password')"
      ></app-form-feedback-list>
    </ng-container>
  </form>
</div>
